import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import {
  NgbModal,
  NgbModalModule,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { environment } from 'src/environments/environment';

import { IconsModule } from '../../icons/icons.module';

@Component({
  selector: 'app-pdf-viewer-modal',
  templateUrl: './pdf-viewer-modal.component.html',
  styleUrls: ['./pdf-viewer-modal.component.css'],
  standalone: true,
  imports: [CommonModule, NgbModalModule, PdfViewerModule, IconsModule],
})
export class PdfViewerModalComponent {
  @Input() pdfFileUrl!: string;

  @ViewChild('content', { static: true }) content!: TemplateRef<HTMLElement>;

  imageMode: boolean = false;

  modalRef!: NgbModalRef;

  proxyUrl: string = '';

  url!: URL;

  constructor(private readonly modalService: NgbModal) {}

  openModal() {
    // smile/erv APIs serve PDFs without a .pdf extension, via our proxy
    const isInsurerApi =
      this.pdfFileUrl.includes('smile-insurances.ch/api') ||
      this.pdfFileUrl.includes('erv.ch/api');
    this.proxyUrl = isInsurerApi
      ? `${environment.apiUrl}api/document-store/v1/proxy/?url=`
      : '';
    this.url = new URL(this.proxyUrl + this.pdfFileUrl);
    this.imageMode =
      !isInsurerApi && !this.pdfFileUrl.toLowerCase().includes('.pdf');
    this.modalRef = this.modalService.open(this.content, {
      scrollable: true,
      size: 'lg',
      centered: true,
    });
  }

  closeModal() {
    if (this.modalRef) this.modalRef.close();
  }

  forceDownload(blob: string, filename: string) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = blob;

    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  downloadResource(url: string) {
    let filename = `${url.split('\\')?.pop()?.split('/')?.pop()?.split('?')?.[0] ?? 'fichier'}`;
    if (!filename.toLowerCase().includes('.pdf')) filename += '.pdf';
    fetch(url, {
      headers: new Headers({
        Origin: location.origin,
      }),
      mode: 'cors',
    })
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        this.forceDownload(blobUrl, filename);
      })
      .catch((e) => console.error(e));
  }
}
